
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import RegionService from '@/services/region.service';
import { IResRegion } from '@/common/interface/region';
import SupplyService from '@/services/supply.service';
import { CDistributorList } from '@/models/supply.model';

@Component
export default class SelectDistributorModal extends Vue {
  visible = false;

  loading = false;

  filterForm: any = {
    dLevel: undefined,
    provinceCode: undefined,
    cityId: undefined,
    code: '',
    companyName: '',
    checked: undefined,
  };

  regionOptions: IResRegion[] = [];

  @lazyInject(RegionService)
  protected regionService!: RegionService;

  @lazyInject(SupplyService)
  protected supplyService!: SupplyService;

  // 当前页原始数据
  list: any[] = [];

  selectedRowKeys: any[] = [];

  scrollY = 400;

  dLevelMap: any = {
    1: '省级',
    2: '地市级',
  };

  columns = [
    {
      title: '编号',
      dataIndex: 'sdCode',
      align: 'center',
      key: 'sdCode',
      width: '120',
    },
    {
      title: '公司全称',
      dataIndex: 'companyName',
      align: 'center',
      key: 'companyName',
    },
    {
      title: '级别',
      dataIndex: 'dLevel',
      align: 'center',
      key: 'dLevel',
      width: '100',
      scopedSlots: { customRender: 'dLevel' },
    },
    {
      title: '省份',
      dataIndex: 'province',
      align: 'center',
      key: 'province',
      width: '120',
    },
    {
      title: '负责区域',
      dataIndex: 'salesRegion',
      align: 'center',
      key: 'salesRegion',
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  // 负责区域跟随省份联动；未选省份时展示全部城市
  get cityOptions(): IResRegion[] {
    const province = this.regionOptions.find(
      (item) => item.id === this.filterForm.provinceCode,
    );
    if (province) {
      return province.child || [];
    }
    return this.regionOptions
      .map((item) => item.child || [])
      .reduce((prev, cur) => prev.concat(cur), []);
  }

  mounted() {
    window.addEventListener('resize', this.calcScrollY);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.calcScrollY);
  }

  // 纵向最大高度按当前页面高度动态计算：视口高度 - 弹窗头部/检索区/表头/分页/底部按钮栏等占用
  calcScrollY() {
    const offset = 420;
    this.scrollY = Math.max(window.innerHeight - offset, 200);
  }

  /** 省市过滤（支持模糊搜索） */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  regionFilterOption(input: string, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  // ids：父组件回传的已选经销商 id 集合，打开时回填勾选状态
  open(ids?: any[]) {
    this.filterForm = {
      dLevel: undefined,
      provinceCode: undefined,
      cityId: undefined,
      code: '',
      companyName: '',
      checked: undefined,
    };
    this.selectedRowKeys = ids || [];
    this.pagination.current = 1;
    this.visible = true;
    this.calcScrollY();
    this.getRegions();
    this.getList();
  }

  async getRegions() {
    if (this.regionOptions.length) {
      return;
    }
    const res = await this.regionService.allRegions();
    if (res && res.length) {
      this.regionOptions = [...res];
    }
  }

  async getList() {
    const province = this.regionOptions.find(
      (item) => item.id === this.filterForm.provinceCode,
    );
    const city = this.cityOptions.find(
      (item) => item.id === this.filterForm.cityId,
    );
    // TODO: 对接经销商列表检索参数（级别/省份/负责区域/编号/经销商名称）
    const res: any = await this.supplyService.getDistributorList({
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
      d_level: this.filterForm.dLevel,
      province: province ? province.name : '',
      city: city ? city.name : '',
      sd_code: this.filterForm.code,
      company_name: this.filterForm.companyName,
    });
    this.loading = false;
    this.list = res && res.list ? res.list.map((item: any) => CDistributorList.from(item)) : [];
    this.pagination.total = (res && res.total) || 0;
  }

  onProvinceChange() {
    this.filterForm.cityId = undefined;
  }

  search() {
    this.pagination.current = 1;
    this.getList();
  }

  resetQuery() {
    this.filterForm = {
      dLevel: undefined,
      provinceCode: undefined,
      cityId: undefined,
      code: '',
      companyName: '',
      checked: undefined,
    };
    this.search();
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getList();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getList();
  }

  // 勾选状态仅维护 id 集合；受控 selectedRowKeys 下翻页/检索后其他页勾选自动保留
  onSelectChange(selectedRowKeys: any[]) {
    this.selectedRowKeys = selectedRowKeys;
  }

  // 清空已勾选项（翻页/检索不会清空，仅此按钮与关闭时重置）
  clearSelection() {
    this.selectedRowKeys = [];
  }

  // 仅向父级回传 id 集合
  submit() {
    console.log('selectedIds', this.selectedRowKeys);
    this.$emit('confirm', [...this.selectedRowKeys]);
    this.onClose();
  }

  onClose() {
    this.visible = false;
    this.list = [];
    this.selectedRowKeys = [];
    this.pagination.current = 1;
    this.pagination.total = 0;
    this.pagination.pageSize = 10;
  }
}
